<app-dialog-base [showLoadingSpinner]="uiState == uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>Failed Audit Details</span>

  <ng-container dialog-content>
    <div class="audit-detail">
      <!-- Header with source badge and timestamp -->
      <div class="audit-header">
        <span class="source-badge" [class]="data.audit.SourceType.toLowerCase()">{{ data.audit.SourceType }}</span>
        <span class="timestamp">{{ data.audit.CreatedOn | date: 'medium' }}</span>
      </div>

      <!-- Metadata grid -->
      <div class="meta-grid">
        <div class="meta-item">
          <span class="meta-label">Event Type</span>
          <span class="meta-value">{{ data.audit.AuditEventTypeId | auditEventTypeToDisplay }}</span>
        </div>
        @if (data.audit.AdminEmail) {
          <div class="meta-item">
            <span class="meta-label">Admin Email</span>
            <span class="meta-value" data-testid="failed-audit-admin-email">{{ data.audit.AdminEmail }}</span>
          </div>
        }
        @if (data.audit.PlayerEmail) {
          <div class="meta-item">
            <span class="meta-label">Player Email</span>
            <span class="meta-value" data-testid="failed-audit-player-email">{{ data.audit.PlayerEmail }}</span>
          </div>
        }
        @if (data.audit.AdminId) {
          <div class="meta-item">
            <span class="meta-label">Admin ID</span>
            <span class="meta-value mono">{{ data.audit.AdminId }}</span>
          </div>
        }
        @if (data.audit.PlayerId) {
          <div class="meta-item">
            <span class="meta-label">Player ID</span>
            <span class="meta-value mono">{{ data.audit.PlayerId }}</span>
          </div>
        }
      </div>

      <!-- Error types -->
      @if (errorTypes.length > 0) {
        <div class="section error-types-section">
          <h4>Error Types</h4>
          @for (errorType of errorTypes; track errorType) {
            <div class="error-item">
              <code>{{ errorType }}</code>
              <span>{{ getErrorTypeName(errorType) }}</span>
            </div>
          }
        </div>
      }

      <!-- Exception -->
      @if (exception) {
        <div class="section exception-section">
          <h4>Exception</h4>
          <pre>{{ exception }}</pre>
        </div>
      }

      <!-- Command -->
      @if (command) {
        <div class="section data-section">
          <h4>Command</h4>
          <pre><app-formatter [data]="command"></app-formatter></pre>
        </div>
      }

      <!-- Result -->
      @if (result) {
        <div class="section data-section">
          <h4>Result</h4>
          <pre><app-formatter [data]="result"></app-formatter></pre>
        </div>
      }

      <!-- Raw data fallback -->
      @if (!command && !result && parsedData) {
        <div class="section data-section">
          <h4>Raw Data</h4>
          <pre><app-formatter [data]="parsedData"></app-formatter></pre>
        </div>
      }
    </div>
  </ng-container>
  <ng-container actions></ng-container>
</app-dialog-base>
